import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';

import OfferView from './OfferView';
import { formatOffers } from '../../../services/OfferService';
import * as offerActions from '../../../redux/offers';
import '../../../helpers';
import './Offer.css';

interface Props {
  type: OfferListType;
  business: Business;
  loadPastOffers: Function;
  loadOffers: Function;
  period?: string;
  offers: { data: Array<Offer>; loading: boolean; past_offers: any };
}

const Loader = styled.div`
  font-family: BrandonGrotesque-Regular;
  font-size: ${(props) => (props.period ? '20px' : '25px')};
  margin: ${(props) => (props.period ? '30px 0px' : '100px 0px')};
  text-align: center;
`;

class OfferList extends React.Component<Props, {}> {
  componentDidMount() {
    const { business, type, period } = this.props;
    if (period) {
      if (this.props.offers.past_offers[period]) {
      } else {
        this.props.loadPastOffers(business.business_id, type, period);
      }
    } else {
      this.props.loadOffers(business.business_id, type);
    }
  }

  render() {
    let data: Array<OfferGroup> = [];
    const loader = <Loader period={this.props.period}>Loading offers...</Loader>;
    const noOffer = <Loader period={this.props.period}>There are no offers</Loader>;

    if (this.props.period) {
      data = formatOffers(this.props.offers.past_offers[this.props.period] || [], this.props.type);
      if (!this.props.offers.past_offers[this.props.period]) return loader;
      if (this.props.offers.past_offers[this.props.period].length === 0) return noOffer;
    } else {
      data = formatOffers(this.props.offers.data, this.props.type);
      if (this.props.offers.loading) return loader;
      if (this.props.offers.data.length === 0) return noOffer;
    }

    return data.map((item) => <OfferView group={item} type={this.props.type} />);
  }
}

const mapStateToProps = ({ business, offers }) => ({
  business,
  offers,
});

export default connect(mapStateToProps, offerActions)(OfferList);
